import { createBrowserRouter, Navigate } from "react-router";

import { ERoutes, DEFAULT_AUTHENTICATED_ROUTE } from "./constants/routes";
import SettingsView from "./view/Settings/Settings";
import BrandsView from "./view/Brands/Brands";
import PromptsView from "./view/Prompts/Prompts";
import ModelsView from "./view/Models/Models";
import ErrorView from "./view/Error/Error";
import AuthView from "./view/Auth/Auth";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ModelsDailyView from "./view/ModelsDaily/ModelsDaily";
import PromptsDailyView from "./view/PromptsDaily/PromptsDaily";
import SettingModelsView from "./view/SettingModels/SettingModels";
import SettingPromptsView from "./view/SettingPrompts/SettingPrompts";
import SettingCompetitorsView from "./view/SettingCompetitors/SettingCompetitors";
import ApiKeysView from "./view/ApiKeys/ApiKeys";
import AddMemberView from "./view/AddMember/AddMember";

import AcceptInvitationView from "./view/AcceptInvitation/AcceptInvitation";
import Login from "./components/Login/Login";
import Register from "./components/Register/Register";
import MainLayout from "./layout/MainLayout/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import PublicRoute from "./components/PublicRoute/PublicRoute";
import LogoutView from "./view/Logout/Logout";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import PaymentSuccessView from "./view/PaymentSuccess/PaymentSuccess";
import SuperuserView from "./view/Superuser/Superuser";
import SuperuserRouteGuard from "./components/SuperuserRouteGuard/SuperuserRouteGuard";
import AddNewBrandView from "./view/AddNewBrand/AddNewBrand";
import OverviewView from "./view/Overview/Overview";
import SourceView from "./view/Source/Source";
import AddNewBrandCompetitorsView from "./view/AddNewBrandCompetitors/AddNewBrandCompetitors";
import SourceDetailView from "./view/SourceDetail/SourceDetail";
import AgencyDashboard from "./view/AgencyDashboard/AgencyDashboard";

import "./assets/css/style.css";



const router = createBrowserRouter([
  {
    element: <PublicRoute />,
    children: [
      {
        element: <AuthView />,
        errorElement: <ErrorView />,
        children: [
          {
            path: ERoutes.Login,
            element: <Login />
          },
          {
            path: ERoutes.Register,
            element: <Register />
          },
          {
            path: ERoutes.ForgotPassword,
            element: <ForgotPassword />
          },
          {
            path: ERoutes.ResetPassword,
            element: <ResetPassword />
          },
          {
            path: '*',
            element: <Navigate to={ERoutes.Login} replace />
          }
        ]
      },
    ]
  },
  {
    path: ERoutes.Logout,
    element: <LogoutView />
  },
  {
    path: ERoutes.InvitationAccept,
    element: <AcceptInvitationView />
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: ERoutes.PaymentSuccess,
        element: <PaymentSuccessView />
      },
      {
        element: <MainLayout />,
        children: [
          {
            path: ERoutes.Home,
            element: <Navigate to={DEFAULT_AUTHENTICATED_ROUTE} replace />
          },
          {
            path: ERoutes.Brands,
            element: <BrandsView />
          },
          {
            path: ERoutes.Overview,
            element: <OverviewView />
          },
          {
            path: ERoutes.Source,
            children: [
              {
                index: true,
                element: <SourceView />
              },
              {
                path: ":id/",
                element: <SourceDetailView />
              }
            ]
          },
          {
            path: ERoutes.PromptsHome,
            children: [
              {
                index: true,
                element: <PromptsView />
              },
              {
                path: ERoutes.Prompts,
                element: <PromptsView />
              },
              {
                path: ERoutes.PromptsDayly,
                element: <PromptsDailyView />
              }
            ]
          },
          {
            path: ERoutes.ModelsHome,
            children: [
              {
                index: true,
                element: <ModelsView />
              },
              {
                path: ERoutes.Models,
                element: <ModelsView />
              },
              {
                path: ERoutes.ModelsDayly,
                element: <ModelsDailyView />
              }
            ]
          },
          {
            path: ERoutes.Superuser,
            element: (
              <SuperuserRouteGuard>
                <SuperuserView />
              </SuperuserRouteGuard>
            )
          },
          {
            path: ERoutes.AddNewBrand,
            element: <AddNewBrandView />
          },
          {
            path: ERoutes.AddNewBrandCompetitors,
            element: <AddNewBrandCompetitorsView />
          },
          {
            path: ERoutes.Agency,
            element: <AgencyDashboard />
          },

          {
            path: ERoutes.Settings,
            children: [
              {
                index: true,
                element: <SettingsView />
              },
              {
                path: ERoutes.SettingsPrompts,
                element: <SettingPromptsView />
              },
              {
                path: ERoutes.SettingsModels,
                element: <SettingModelsView />
              },
              {
                path: ERoutes.SettingsCompetitors,
                element: <SettingCompetitorsView />
              },
              {
                path: ERoutes.SettingsApiKeys,
                element: <ApiKeysView />
              },
              {
                path: ERoutes.SettingsAddMember,
                element: <AddMemberView />
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    element: <ErrorView />
  }
]);

export default router; 